import React from 'react'
import styles from './current-skeleton-entry.styles'
import injectSheet from 'react-jss'
import { TableRow, Cell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'

const CurrentSkeletonEntry = ({ classes, titleWidth }) => (
  <TableRow>
    <Cell>
      <Bone className={classes.checkbox} />
    </Cell>
    <Cell>
      <Bone className={classes.received} />
    </Cell>
    <Cell>
      <Bone className={classes.received} />
    </Cell>
    <Cell>
      <Bone style={{ width: titleWidth + 'px' }} />
    </Cell>
    <Cell className={classes.conclusionCell}>
      <Bone className={classes.conclusion} />
    </Cell>
    <Cell right>
      <Bone className={classes.context} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(CurrentSkeletonEntry)
